<div class="logo-container">
  <a class="logo-mp-link" target="_blank" [href]="'LOGO.MP_LINK' | translate" aria-label="United Mileageplus logo, link opens in new tab">
    <img [src]="imageBaseUrl + 'img/mp_logo.png'" alt="United Mileageplus logo" />
  </a>
  <div class="logo-chase-link">
    <img [src]="imageBaseUrl + 'img/ihg_logo_alt.svg'" alt="IHG One Rewards logo" />
  </div>
</div>